// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page":"page_3_aYw","current":"current_1IxJs"};